<form
  action=""
  method=""
  class="needs-validation register-form mrse-20 mrtb-10"
  [formGroup]="signUpForm"
  (ngSubmit)="signUp()"
>
  <div>
    <div class="row">
      <div class="col-lg-6">
        <div class="mrtb-10">
          <label class="d-block size-6 weight-600 mrb-2" for="firstName">{{
            "account.firstName" | translate
          }}</label>
          <input
            class="w-100 border-0 border-radius-10 p-4"
            type="text"
            nbInput
            fullWidth
            placeholder="{{ 'account.firstName' | translate }}"
            formControlName="firstName"
            id="firstName"
            [class.is-invalid]="
              firstName?.invalid && (firstName?.dirty || firstName?.touched)
            "
            required
          />
          <div class="invalid-feedback">
            <p *ngIf="firstName?.errors?.invalid">
              {{ "account.firstName" | translate }}
              {{ "isInvalid" | translate }}
            </p>
            <p *ngIf="firstName?.errors?.required">
              {{ "account.firstName" | translate }}
              {{ "isRequired" | translate }}
            </p>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="mrtb-10">
          <label class="d-block size-6 weight-600 mrb-2" for="lastName">{{
            "account.lastName" | translate
          }}</label>
          <input
            class="w-100 border-0 border-radius-10 p-4"
            type="text"
            nbInput
            fullWidth
            placeholder="{{ 'account.lastName' | translate }}"
            formControlName="lastName"
            id="lastName"
            [class.is-invalid]="
              lastName?.invalid && (lastName?.dirty || lastName?.touched)
            "
            required
          />
          <div class="invalid-feedback">
            <p *ngIf="lastName?.errors?.invalid">
              {{ "account.lastName" | translate }} {{ "isInvalid" | translate }}
            </p>
            <p *ngIf="lastName?.errors?.required">
              {{ "account.lastName" | translate }}
              {{ "isRequired" | translate }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-6">
        <div class="mrtb-10">
          <label
            class="d-block size-6 weight-600 mrb-2"
            for="national_number"
            >{{ "account.national_number" | translate }}</label
          >
          <input
            class="w-100 border-0 border-radius-10 p-4"
            type="text"
            nbInput
            fullWidth
            placeholder="{{ 'account.national_number_p_holder' | translate }}"
            formControlName="national_number"
            id="national_number"
            [class.is-invalid]="
              national_number?.invalid &&
              (national_number?.dirty || national_number?.touched)
            "
            required
          />
          <div class="invalid-feedback">
            <p *ngIf="national_number?.errors?.invalid">
              {{ "account.national_number" | translate }}
              {{ "isInvalid" | translate }}
            </p>
            <p *ngIf="national_number?.errors?.required">
              {{ "account.national_number" | translate }}
              {{ "isRequired" | translate }}
            </p>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="mrtb-10">
          <label class="d-block size-6 weight-600 mrb-2" for="country_id">{{
            "account.nationality" | translate
          }}</label>
          <select
            class="w-100 border-0 border-radius-10 p-4"
            name="country_id"
            id="country_id"
            [class.is-invalid]="
              country_id?.invalid && (country_id?.dirty || country_id?.touched)
            "
            formControlName="country_id"
            required
          >
            <option value="" disabled selected>
              {{ "account.nationality" | translate }}
            </option>
            <option
              [value]="country.country_id"
              *ngFor="let country of countries"
            >
              {{ country.country_name }}
            </option>
          </select>
          <div class="invalid-feedback">
            <p *ngIf="country_id?.errors?.required">
              {{ "account.nationality" | translate }}
              {{ "isRequired" | translate }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-6">
        <div class="mrtb-10">
          <label class="d-block size-6 weight-600 mrb-2" for="email">{{
            "account.mail" | translate
          }}</label>
          <input
            class="w-100 border-0 border-radius-10 p-4"
            type="email"
            name="email"
            id="email"
            nbInput
            fullWidth
            placeholder="{{ 'account.mail' | translate }}"
            formControlName="email"
            [class.is-invalid]="
              email?.invalid && (email?.dirty || email?.touched)
            "
            required
          />
          <div class="invalid-feedback">
            <p *ngIf="email?.errors?.invalid">
              {{ "account.mail" | translate }} {{ "isInvalid" | translate }}
            </p>
            <p *ngIf="email?.errors?.required">
              {{ "account.mail" | translate }} {{ "isRequired" | translate }}
            </p>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="mrtb-10">
          <label class="d-block size-6 weight-600 mrb-2" for="phone">{{
            "account.phone" | translate
          }}</label>
          <input
            class="w-100 border-0 border-radius-10 p-4"
            type="text"
            nbInput
            fullWidth
            placeholder="{{ 'account.phone_p_holder' | translate }}"
            formControlName="phone"
            id="phone"
            [class.is-invalid]="
              phone?.invalid && (phone?.dirty || phone?.touched)
            "
            required
          />
          <div class="invalid-feedback">
            <p *ngIf="phone?.errors?.invalid">
              {{ "account.phone" | translate }} {{ "isInvalid" | translate }}
            </p>
            <p *ngIf="phone?.errors?.required">
              {{ "account.phone" | translate }} {{ "isRequired" | translate }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-6">
        <div class="mrtb-15">
          <label class="d-block size-6 weight-600 mrb-2" for="password">{{
            "account.setPassword" | translate
          }}</label>
          <div class="position-relative height-40">
            <input
              class="w-100 border-0 border-radius-10 p-4"
              type="password"
              name="password"
              id="password"
              appPassword
              nbInput
              fullWidth
              placeholder="{{ 'account.setPassword' | translate }}"
              formControlName="password"
              [class.is-invalid]="
                password?.invalid && (password?.dirty || password?.touched)
              "
              required
            />
            <div class="invalid-feedback">
              <p *ngIf="password?.errors?.pattern">
                {{ "account.setPassword" | translate }}
                {{ "isInvalid" | translate }}
              </p>

              <p *ngIf="password?.errors?.required">
                {{ "account.setPassword" | translate }}
                {{ "isRequired" | translate }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="mrtb-15">
          <label
            class="d-block size-6 weight-600 mrb-2"
            for="confirm_password"
            >{{ "account.confirm_Password" | translate }}</label
          >
          <div class="position-relative height-40">
            <input
              appPassword
              class="w-100 border-0 border-radius-10 p-4"
              type="password"
              name="confirm_password"
              id="confirm_password"
              nbInput
              fullWidth
              placeholder="{{ 'account.confirm_Password' | translate }}"
              formControlName="confirm_password"
              [class.is-invalid]="
                confirm_password?.invalid &&
                (confirm_password?.dirty || confirm_password?.touched)
              "
              required
            />
            <div class="invalid-feedback">
              <p *ngIf="confirm_password?.errors?.invalid">
                {{ "account.confirm_Password" | translate }}
                {{ "isInvalid" | translate }}
              </p>
              <p *ngIf="confirm_password?.errors?.required">
                {{ "account.confirm_Password" | translate }}
                {{ "isRequired" | translate }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="mrtb-10">
    <label class="d-block weight-600 mrb-5" for="sex_p">{{ 'account.type' | translate}}</label>
    <select class="w-100 border border-radius-10 p-5" name="sex_p" id="sex_p"
      [class.is-invalid]="sex_p?.invalid && (sex_p?.dirty ||sex_p?.touched)"
      formControlName="sex_p" >
        <option value="" disabled selected>{{ 'account.type'| translate }}</option>
        <option [value]="sexe.key"  *ngFor="let sexe of sexes | keyvalue">{{ sexe.value }}</option>
    </select>
    <div class="invalid-feedback">
      <p *ngIf="sex_p?.errors?.required">
          {{ 'account.type'| translate }} {{ 'isRequired'| translate }}
      </p>
    </div>
  </div> -->
    <button
      [disabled]="signUpForm.invalid"
      type="submit"
      class="btn rounded-2 w-100 bg-primary border-0 border-radius-10 p-5 text-white size-8 weight-600"
    >
      {{ "account.createAccount" | translate }}
    </button>
  </div>
  <!-- <div *ngIf="!fistStep">

    <div class="mrtb-10">
      <label class="d-block weight-600 mrb-5" for="marital_status_p">{{ 'account.martial_status' | translate}}</label>
      <select class="w-100 border border-radius-10 p-5" name="marital_status_p" id="marital_status_p"
        [class.is-invalid]="marital_status_p?.invalid && (marital_status_p?.dirty ||marital_status_p?.touched)"
        formControlName="marital_status_p" >
          <option value="" disabled selected>{{ 'account.martial_status'| translate }}</option>
          <option [value]="martial.key"  *ngFor="let martial of martialStatus | keyvalue">{{ martial.value }}</option>
      </select>
      <div class="invalid-feedback">
        <p *ngIf="marital_status_p?.errors?.required">
            {{ 'account.martial_status'| translate }} {{ 'isRequired'| translate }}
        </p>
      </div>
    </div>

    <div class="mrtb-10">
      <label class="d-block weight-600 mrb-5" for="doctor_p_id">{{ 'account.doctor' | translate}}</label>
      <select class="w-100 border border-radius-10 p-5" name="doctor_p_id" id="doctor_p_id"
        [class.is-invalid]="doctor_p_id?.invalid && (doctor_p_id?.dirty ||doctor_p_id?.touched)"
        formControlName="doctor_p_id" >
          <option value="" disabled selected>{{ 'account.doctor'| translate }}</option>
          <option [value]="doctor.doctor_p_id"  *ngFor="let doctor of doctors">{{ doctor.doctor_p_name }}</option>
      </select>
      <div class="invalid-feedback">
        <p *ngIf="doctor_p_id?.errors?.required">
            {{ 'account.doctor'| translate }} {{ 'isRequired'| translate }}
        </p>
      </div>
    </div>
    <div class="mrtb-10">
      <label class="d-block weight-600 mrb-5" for="patient_source_p_id">{{ 'account.patientSource' | translate}}</label>
      <select class="w-100 border border-radius-10 p-5" name="patient_source_p_id" id="patient_source_p_id"
        [class.is-invalid]="patient_source_p_id?.invalid && (patient_source_p_id?.dirty ||patient_source_p_id?.touched)"
        formControlName="patient_source_p_id" >
          <option value="" disabled selected>{{ 'account.patientSource'| translate }}</option>
          <option [value]="patientSource.patient_source_p_id"  *ngFor="let patientSource of patientSources">{{ patientSource.patient_source_p_name }}</option>
      </select>
      <div class="invalid-feedback">
        <p *ngIf="patient_source_p_id?.errors?.required">
            {{ 'account.patientSource'| translate }} {{ 'isRequired'| translate }}
        </p>
      </div>
    </div>
    <div class="mrtb-10">
      <label class="d-block weight-600 mrb-5" for="dob_p">{{ 'vacancy.dateOfBirth'| translate
          }}</label>
      <input class="w-100 border border-radius-10 p-5" type="date" id="dob_p"
          name="dob_p" required formControlName="dob_p" [class.is-invalid]="dob_p?.invalid && (dob_p?.dirty || dob_p?.touched)" />
      <div class="invalid-feedback">
        <p *ngIf="dob_p?.errors?.invalid">
            {{ 'vacancy.dateOfBirth'| translate }} {{ 'isInvalid'| translate }}
        </p>
        <p *ngIf="dob_p?.errors?.required">
            {{ 'vacancy.dateOfBirth'| translate }} {{ 'isRequired'| translate }}
        </p>
      </div>
    </div>
    <div class="mrtb-10 actions">
        <button (click) ="signUp()" type="button" class="f-btn w-100 bg-primary border-0 border-radius-10 p-5 text-white size-8 weight-600">
                  {{'account.back' | translate}}
              </button>
        <button class="w-100 bg-primary border-0 border-radius-10 p-5 text-white size-8 weight-600" type="submit"
            [disabled]="isSubmitting || signUpForm.invalid">
            <span *ngIf="!isSubmitting"> {{ 'account.createAccount' | translate}}</span>
            <img *ngIf="isSubmitting" src="../../../../assets/images/spinner.gif" alt="" class="max-30">
        </button>
        <div class="cursor-pointer  text-center mrt-5 weight-600" (click)="navigateLogin()">{{ 'account.youHaveAnAccount'
            | translate}}</div>
    </div>
  </div> -->
</form>
